import { sanitizeString } from '../utils';
import { stringToBoolean } from 'Shared/utils';
import { ClientRequestType, ServerDriversRequestType } from './types';

export const transformDriverLicenseRequest = (
  data: ClientRequestType
): ServerDriversRequestType => {
  return {
    state: sanitizeString(data.licenseState),
    status: sanitizeString(data.licenseStatus),
    reportStatus: sanitizeString(data.licenseReportStatus),
    verified: stringToBoolean(data.licenseVerified),
    reasonText: sanitizeString(data.reasonText),
  };
};
